import { TestCard } from "./testcard";

export function MockTestList({ list = [], loading, evaluateExam}) {
  return (
    <div className="flex-1 flex items-center flex-col bg-gradient-to-br from-[#0f1923] via-[#1a2332] to-[#0f1923]">
      {/* Header */}
      <header className="w-full border-b border-yellow-400/20 bg-[#0f1923]">
        <div className="w-fit max-w-6xl mx-auto p-2 flex items-center gap-3">
          <h1 className="text-2xl font-bold text-white m-0 tracking-tight">
            <span className="font-extrabold inline-block mr-[2px]">2</span>
            <span className="text-yellow-400 font-extrabold">xcell</span>
          </h1>

          <div className="h-6 w-px bg-white/20 mx-2"></div>

          <span className="text-sm text-white/60 font-medium">Mock Tests</span>
        </div>
      </header>

      {/* Content */}
      <section className="py-12 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl text-white mb-3 tracking-tight">
            <span className="font-extrabold">Available</span>{" "}
            <span className="text-yellow-400 font-extrabold">Mock Tests</span>
          </h2>

          <p className="text-white/60 mb-10 text-base sm:text-lg">
            Browse and evaluate AI-graded mock tests
          </p>
          {!loading && list.length ? (
            <>
              <div className="grid md:grid-cols-2 gap-6 mb-8 overflow-auto">
                {list?.map((exam, i) => (
                  <TestCard
                    key={i}
                    exam={exam}
                    evaluateExam={() => evaluateExam(exam.id)}
                  />
                ))}
              </div>

              {/* Pagination 
              <div className="flex justify-center items-center gap-4">
                <button
                  disabled
                  className="px-4 py-2 rounded-lg text-white/70 border border-white/20 disabled:opacity-30 disabled:cursor-not-allowed hover:text-white transition"
                >
                  Previous
                </button>
                <button className="px-4 py-2 rounded-lg text-white border border-white/20 hover:text-yellow-400 hover:border-yellow-400 transition">
                  Next
                </button>
              </div>*/}
            </>
          ) : (
            <p className="text-white/80 text-sm py-30">
              {loading
                ? "Loading mock tests..."
                : "No mock tests available at the moment."}
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
